import { Observable } from 'rxjs';
import { CartResponse } from '../models/cart-response.model';
import { CartCoverages } from '../models/cart-request.model';

export abstract class CartRepository {
    abstract getCart(): Observable<CartResponse>;
    abstract createCart(
        cartCoverages: CartCoverages[],
    ): Observable<CartResponse>;
}
